module.exports = __webpack_public_path__ + "lerk-background.jpg?529925423b7f3c9315d2bfc9abdcf4fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/djs/lerk-background.jpg
// module id = 385
// module chunks = 0